/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Done_TitleInputs */

const en_consult_done_title = /** @type {(inputs: Consult_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanks — we'll be in touch`)
};

const id_consult_done_title = /** @type {(inputs: Consult_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makasih — kami segera hubungi`)
};

/**
* | output |
* | --- |
* | "Thanks — we'll be in touch" |
*
* @param {Consult_Done_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_done_title = /** @type {((inputs?: Consult_Done_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Done_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_done_title(inputs)
	return en_consult_done_title(inputs)
});